import React from "react";
import { Route, Switch } from "react-router-dom";

// Components/Pages
import DashboardPage from "../../pages/dashboard/DashboardPage";
import ProjectsPage from "../../pages/projects/view-projects/ProjectsPage";
import CreateProjectPage from "../../pages/projects/create-project/CreateProjectPage";
import ProjectSewerObjectsPage from "../../pages/projects/project-sewer-objects/ProjectSewerObjectsPage";
import ProjectJobsPage from "../../pages/projects/project-jobs/ProjectJobsPage";
import ProjectMembersPage from "../../pages/projects/project-members/ProjectMembersPage";
import UsersPage from "../../pages/users/UsersPage";
import OrganizationDetailsPage from "../../pages/settings/organization-details/view-organization/OrganizationDetailsPage";
import EditOrganizationPage from "../../pages/settings/organization-details/edit-organization/EditOrganizationPage";
import InviteUserPage from "../../pages/users/invite-user/InviteUserPage";
import ViewUserPage from "../../pages/users/user-details/view-user/ViewUserPage";
import ViewUserUsagePage from "../../pages/users/user-details/usage/ViewUserUsagePage";
import EditUserPage from "../../pages/users/user-details/edit-user/EditUserPage";
import EditMyAccountDetailsPage from "../../pages/users/user-details/edit-user/EditMyAccountDetailsPage";
import JobsPage from "../../pages/jobs/view-jobs/JobsPage";
import EditJobPage from "../../pages/jobs/job-details/edit-job/EditJobPage";
import CreateJobPage from "../../pages/jobs/create-job/CreateJobPage";
import ViewJob from "../../pages/jobs/job-details/view-job/ViewJobPage";
import JobSewerObjectsPage from "../../pages/jobs/JobSewerObjectsPage";
import ViewSectionPage from "../../pages/sewer-objects/section-details/ViewSectionPage";
import EditSectionPage from "../../pages/sewer-objects/section-details/EditSectionPage";
import ViewStructureOnMapPage from "../../pages/sewer-objects/structure-details/ViewStructureOnMapPage";
import ViewSectionOnMapPage from "../../pages/sewer-objects/section-details/ViewSectionOnMapPage";
import ViewNodeOnMapPage from "../../pages/sewer-objects/node-details/ViewNodeOnMapPage";
import InspectionsPage from "../../pages/inspections/InspectionsPage";
import ViewDamagePage from "../../pages/damages/damage-details/view-damage/ViewDamagePage";
import Page404 from "../../pages/404/Page404";
import ViewInspectionDetailsPage from "../../pages/inspections/inspection-details/view-inspection/ViewInspectionPage";
import DamagesPage from "../../pages/damages/DamagesPage";
import ViewProjectPage from "../../pages/projects/project-details/view-project/ViewProjectPage";
import EditProjectPage from "../../pages/projects/project-details/edit-project/EditProjectPage";
import EditInspectionPage from "../../pages/inspections/inspection-details/edit-inspection/EditInspectionPage";
import EditDamagePage from "../../pages/damages/damage-details/edit-damage/EditDamagePage";
import InspectionFilesPage from "../../pages/inspections/InspectionFilesPage";
import InspectionReportPage from "../../pages/inspections/InspectionReportPage";
import MyAccountDetailsPage from "../../pages/my-account/my-account-details/MyAccountDetailsPage";
import OrganizationsPage from "../../pages/my-account/MyOrganizationsPage";
import OrganizationRequestsPage from "../../pages/my-account/MyOrganizationRequestsPage";
import ViewGisCoordinatesPage from "../../pages/settings/gis-coordinates/ViewGisCoordinatesPage";
import EditGisCoordinatesPage from "../../pages/settings/gis-coordinates/EditGisCoordinatesPage";
import ViewAnalysisConfidencePage from "../../pages/settings/analysis-confidence/ViewAnalysisConfidencePage";
import EditAnalysisConfidencePage from "../../pages/settings/analysis-confidence/EditAnalysisConfidencePage";
import RemovedUsersPage from "../../pages/settings/removed-users/RemovedUsersPage";
import ViewProjectPropertiesPage from "../../pages/settings/project-details/ProjectPropertiesPage";
import ViewProjectPropertyPage from "../../pages/settings/project-details/ViewProjectPropertyPage";
import CreateProjectPropertyPage from "../../pages/settings/project-details/CreateProjectPropertyPage";
import RequestOrganizationPage from "../../pages/my-account/request-organization/RequestOrganizationPage";
import ViewMyCollaborationRequestsPage from "../../pages/my-account/MyCollaborationRequestsPage";
import PlanUsagePage from "../../pages/subscription/usage/PlanUsagePage";
import PlansPage from "../../pages/subscription/plans/PlansPage";
import BillingDetails from "../../pages/subscription/billing/BillingDetailsPage";
import LandingPage from "../../pages/landing-page/LandingPage";
import HelpPage from "../../pages/help/HelpPage";
import ViewNodePage from "../../pages/sewer-objects/node-details/ViewNodePage";
import EditNodePage from "../../pages/sewer-objects/node-details/EditNodePage";
import ViewStructurePage from "../../pages/sewer-objects/structure-details/ViewStructurePage";
import EditStructurePage from "../../pages/sewer-objects/structure-details/EditStructurePage";
import DeletedDataPage from "../../pages/settings/deleted-data/DeletedDataPage";
import SectionLinkedObjectsPage from "../../pages/sewer-objects/SectionLinkedObjectsPage";
import NodeLinkedObjectsPage from "../../pages/sewer-objects/NodeLinkedObjectsPage";
import StructureLinkedObjectsPage from "../../pages/sewer-objects/StructureLinkedObjectsPage";
import ReportTemplatesPage from "../../pages/settings/report-templates/ReportTemplatesPage";
import AnalysisPage from "../../pages/analysis/AnalysisPage";
import CreateDamageFromAnalysisPage from "../../pages/analysis/create-damage/CreateDamageFromAnalysisPage";
import CreateDamageFromDamagesPage from "../../pages/damages/create-damage/CreateDamageFromDamagesPage";
import ProjectSewerObjectsMapPage from "../../pages/projects/project-map/ProjectSewerObjectsMapPage";
import { featureFlagsStorage } from "../../services/feature-flags/FeatureFlagsStorage";
import JobSewerObjectsMapPage from "../../pages/jobs/JobSewerObjectsMapPage";
import { Flags } from "../../generated/FeatureFlags";
import ProjectInspectionsPage from "../../pages/projects/inspections/ProjectInspectionsPage";

export default function RoutesComponent() {
  return (
    <Switch>
      <Route path="/" exact component={DashboardPage} />
      <Route path="/" exact component={LandingPage} />

      <Route path="/projects" exact component={ProjectsPage} />
      <Route path="/projects/create-project" exact component={CreateProjectPage} />
      <Route path="/projects/:projectId/sewer-objects" exact component={ProjectSewerObjectsPage} />
      <Route path="/projects/:projectId/map" exact component={ProjectSewerObjectsMapPage} />
      <Route path="/projects/:projectId/jobs" exact component={ProjectJobsPage} />
      <Route path="/projects/:projectId/members" exact component={ProjectMembersPage} />
      <Route path="/projects/:projectId/inspections" exact component={ProjectInspectionsPage} />
      <Route path="/projects/:projectId" exact component={ViewProjectPage} />
      <Route path="/projects/:projectId/edit" exact component={EditProjectPage} />

      <Route path="/jobs" exact component={JobsPage} />
      <Route path="/jobs/create-job" exact component={CreateJobPage} />
      <Route path="/jobs/:jobId" exact component={ViewJob} />
      <Route path="/jobs/:jobId/edit" exact component={EditJobPage} />
      <Route path="/jobs/:jobId/sewer-objects" exact component={JobSewerObjectsPage} />
      <Route path="/jobs/:jobId/map" exact component={JobSewerObjectsMapPage} />

      <Route path="/users" exact component={UsersPage} />
      <Route path="/users/invite-user" exact component={InviteUserPage} />
      <Route path="/users/:userId" exact component={ViewUserPage} />
      <Route path="/users/:userId/edit" exact component={EditUserPage} />
      <Route path="/users/:userId/va-usage" exact component={ViewUserUsagePage} />

      <Route path="/subscription/usage" exact component={PlanUsagePage} />
      <Route path="/subscription/plans" exact component={PlansPage} />
      <Route path="/subscription/billing" exact component={BillingDetails} />

      <Route path="/settings/organization-details" exact component={OrganizationDetailsPage} />
      {featureFlagsStorage.isFeatureEnabled(Flags.Show_Page_Report_Templates) && (
        <Route path="/settings/report-templates" exact component={ReportTemplatesPage} />
      )}
      <Route path="/settings/organization-details/edit" exact component={EditOrganizationPage} />
      <Route path="/settings/project-properties" exact component={ViewProjectPropertiesPage} />
      <Route
        path="/settings/project-properties/create"
        exact
        component={CreateProjectPropertyPage}
      />
      <Route
        path="/settings/project-properties/:projectPropertyId"
        exact
        component={ViewProjectPropertyPage}
      />
      <Route path="/settings/gis-coordinates" exact component={ViewGisCoordinatesPage} />
      <Route path="/settings/gis-coordinates/edit" exact component={EditGisCoordinatesPage} />
      <Route path="/settings/analysis-confidence" exact component={ViewAnalysisConfidencePage} />
      <Route
        path="/settings/analysis-confidence/edit"
        exact
        component={EditAnalysisConfidencePage}
      />
      <Route path="/settings/removed-users" exact component={RemovedUsersPage} />
      {featureFlagsStorage.isFeatureEnabled(Flags.Show_Page_Deleted_Data) && (
        <Route path="/settings/deleted-data" exact component={DeletedDataPage} />
      )}

      <Route
        path="/projects/:projectId/sewer-objects/node/:nodeId"
        exact
        component={ViewNodePage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId"
        exact
        component={ViewSectionPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/structure/:structureId"
        exact
        component={ViewStructurePage}
      />

      <Route path="/jobs/:jobId/sewer-objects/node/:nodeId" exact component={ViewNodePage} />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId"
        exact
        component={ViewSectionPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/structure/:structureId"
        exact
        component={ViewStructurePage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/node/:nodeId/edit"
        exact
        component={EditNodePage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/edit"
        exact
        component={EditSectionPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/structure/:structureId/edit"
        exact
        component={EditStructurePage}
      />

      <Route path="/jobs/:jobId/sewer-objects/node/:nodeId/edit" exact component={EditNodePage} />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/edit"
        exact
        component={EditSectionPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/structure/:structureId/edit"
        exact
        component={EditStructurePage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/node/:nodeId/map"
        exact
        component={ViewNodeOnMapPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/map"
        exact
        component={ViewSectionOnMapPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/structure/:structureId/map"
        exact
        component={ViewStructureOnMapPage}
      />

      <Route
        path="/jobs/:jobId/sewer-objects/node/:nodeId/map"
        exact
        component={ViewNodeOnMapPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/map"
        exact
        component={ViewSectionOnMapPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/structure/:structureId/map"
        exact
        component={ViewStructureOnMapPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/node/:nodeId/linked-objects"
        exact
        component={NodeLinkedObjectsPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/linked-objects"
        exact
        component={SectionLinkedObjectsPage}
      />
      <Route
        path="/projects/:projectId/sewer-objects/structure/:structureId/linked-objects"
        exact
        component={StructureLinkedObjectsPage}
      />

      <Route
        path="/jobs/:jobId/sewer-objects/node/:nodeId/linked-objects"
        exact
        component={NodeLinkedObjectsPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/linked-objects"
        exact
        component={SectionLinkedObjectsPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/structure/:structureId/linked-objects"
        exact
        component={StructureLinkedObjectsPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections"
        exact
        component={InspectionsPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections"
        exact
        component={InspectionsPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId"
        exact
        render={(props) => <ViewInspectionDetailsPage key={props.match.params.inspectionId} />}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId"
        exact
        render={(props) => <ViewInspectionDetailsPage key={props.match.params.inspectionId} />}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/edit"
        exact
        component={EditInspectionPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/edit"
        exact
        component={EditInspectionPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/files"
        exact
        render={(props) => <InspectionFilesPage key={props.match.params.inspectionId} />}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/files"
        exact
        render={(props) => <InspectionFilesPage key={props.match.params.inspectionId} />}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages"
        exact
        render={(props) => <DamagesPage key={props.match.params.inspectionId} />}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages"
        exact
        render={(props) => <DamagesPage key={props.match.params.inspectionId} />}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/create-damage"
        exact
        component={CreateDamageFromDamagesPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/create-damage"
        exact
        component={CreateDamageFromDamagesPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/:damageId"
        exact
        component={ViewDamagePage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/:damageId"
        exact
        component={ViewDamagePage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/:damageId/edit"
        exact
        component={EditDamagePage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/damages/:damageId/edit"
        exact
        component={EditDamagePage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/analysis/create-damage"
        exact
        component={CreateDamageFromAnalysisPage}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/analysis/create-damage"
        exact
        component={CreateDamageFromAnalysisPage}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/analysis"
        exact
        render={(props) => <AnalysisPage key={props.match.params.inspectionId} />}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/analysis"
        exact
        render={(props) => <AnalysisPage key={props.match.params.inspectionId} />}
      />

      <Route
        path="/projects/:projectId/sewer-objects/section/:sectionId/inspections/:inspectionId/report"
        exact
        render={(props) => <InspectionReportPage key={props.match.params.inspectionId} />}
      />
      <Route
        path="/jobs/:jobId/sewer-objects/section/:sectionId/inspections/:inspectionId/report"
        exact
        render={(props) => <InspectionReportPage key={props.match.params.inspectionId} />}
      />

      <Route path="/my-account" exact component={MyAccountDetailsPage} />
      <Route path="/my-account/edit" exact component={EditMyAccountDetailsPage} />
      <Route path="/my-account/organizations" exact component={OrganizationsPage} />
      <Route
        path="/my-account/organizations/organization-requests"
        exact
        component={OrganizationRequestsPage}
      />
      <Route
        path="/my-account/organizations/request-organization"
        exact
        component={RequestOrganizationPage}
      />
      <Route
        path="/my-account/organizations/collaboration-requests"
        exact
        component={ViewMyCollaborationRequestsPage}
      />

      <Route path="/help" exact component={HelpPage} />
      <Route path="/404" exact component={Page404} />
      <Route component={Page404} />
    </Switch>
  );
}
